"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _SpeakerPage = _interopRequireDefault(require("../SpeakerPage"));
var _Text = _interopRequireDefault(require("../Text"));
var __jsx = _react.default.createElement;
var SpeakersList = function SpeakersList(_ref) {
  var _ref$speakersList = _ref.speakersList,
    speakersList = _ref$speakersList === void 0 ? [] : _ref$speakersList,
    heading = _ref.heading;
  if (!speakersList || speakersList.length === 0) return null;
  heading = "<h3>".concat(heading, "</h3>");
  return __jsx("div", null, __jsx(_Text.default, {
    text: heading
  }), speakersList.map(function (speaker, index) {
    return __jsx(_SpeakerPage.default, (0, _extends2.default)({
      key: index
    }, speaker));
  }));
};
var SpeakersListEditConfig = {
  emptyLabel: 'Speakers List',
  isEmpty: function isEmpty(props) {
    return !(props.speakersList && props.speakersList.length > 0);
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/speakers-list')(SpeakersList, SpeakersListEditConfig);
exports.default = _default;